import { j as m } from "./element-CV9utnHJ.js";
/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const { I: l } = m, c = (t) => t, B = (t) => t.strings === void 0, f = () => document.createComment(""), g = (t, i, A) => {
  var o;
  const e = t._$AA.parentNode, r = i === void 0 ? t._$AB : i._$AA;
  if (A === void 0) {
    const _ = e.insertBefore(f(), r), $ = e.insertBefore(f(), r);
    A = new l(_, $, t, t.options);
  } else {
    const _ = A._$AB.nextSibling, $ = A._$AM, s = $ !== t;
    if (s) {
      let n;
      (o = A._$AQ) == null || o.call(A, t), A._$AM = t, A._$AP !== void 0 && (n = t._$AU) !== $._$AU && A._$AP(n);
    }
    if (_ !== r || s) {
      let n = A._$AA;
      for (; n !== _; ) {
        const d = c(n).nextSibling;
        c(e).insertBefore(n, r), n = d;
      }
    }
  }
  return A;
}, u = (t, i, A = t) => (t._$AI(i, A), t), v = {}, x = (t, i = v) => t._$AH = i, M = (t) => t._$AH, a = (t) => {
  t._$AR(), t._$AA.remove();
};
export {
  M,
  a as h,
  x as p,
  B as r,
  u,
  g as v
};
